exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-packet-img[data-v-2e2d14bf]{display:block;line-height:0px}.red-packet-img .upload-inner__box[data-v-2e2d14bf]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.red-packet-img .red-packet-img-icon[data-v-2e2d14bf]{margin-right:10px;border:1px dashed #d9d9d9;border-radius:6px;font-size:28px;color:#8c939d;width:78px;height:78px;line-height:78px;text-align:center}", ""]);

// exports
